/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { lineStyle } from "@monsma/App/Components/LineContainer/LineContainer";
import { savedOrderDetailsCartLineStyles } from "@monsma/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.inactiveProductLabel = {
    size: 13,
    color: "danger",
    weight: "bold",
    css: css`
        margin-top: 5px;
    `,
};

savedOrderDetailsCartLineStyles.xSavedOrderCartLine = {
    customProductPrice: {
        price: lineStyle.productPrice?.price,
    },
    addToListLink: {
        ...lineStyle.addToListLink,
        css: css`
            ${lineStyle.addToListLink?.css}
            left: 0;
            right: auto;
        `,
    },
};

savedOrderDetailsCartLineStyles.subtotalWithoutVatText = {
    ...sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent,
    wrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
};

savedOrderDetailsCartLineStyles.vatAmount = savedOrderDetailsCartLineStyles.subtotalWithoutVatText;

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = savedOrderDetailsCartLineStyles.subtotalWithoutVatText;
